import CopilotThreadsAPI from 'dashboard/api/polaris/copilotThreads';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CopilotThreads',
  API: CopilotThreadsAPI,
});
